"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
class Notification {
    constructor(props) {
        this.assignation_id = props?.assignation_id || null;
        this.country = props?.country || null;
        this.uid = props?.uid || null;
        this.uidReceiver = props?.uidReceiver || null;
        this.campaign = props?.campaign || null;
        this.forever = props?.forever || false;
        this.id = props?.id || null;
        this.next_send = props?.next_send || null;
        this.send = props?.send || [];
        this.timestamps = props?.timestamps || null;
    }
}
exports.Notification = Notification;
